module.exports = __webpack_public_path__ + "static/media/community.b23d13d0.png";